(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.DeleteServiceController', [
		'mx.SolutionBuilderAgent.ExternalServiceManager',
		'mx.shell.EventService',
		'mx.shell.SidePanelService',
		'$q',
		'mx.shell.NotificationService',
		'mx.internationalization',
		function deleteServiceCtrl(externalServiceManager, eventService, sidePanelService, $q, notificationService, internationalization) {
			var vm = this;

			vm.execute = function (selectedObjects, action) {
				if (!selectedObjects || !selectedObjects.length) {
					return;
				}

				var groupedObjectsByService = _.groupBy(selectedObjects, '_type');
				var type;

				var allResults = [];
				for (type in groupedObjectsByService) {
					if (groupedObjectsByService.hasOwnProperty(type)) {
						allResults.push(externalServiceManager.deleteObjects(type, groupedObjectsByService[type]));
					}
				}

				$q.all(allResults).then(actionProxy, actionProxy).then(reloadPage);

				function actionProxy() {
					return action;
				}
			};

			function reloadPage(action) {
				eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.SearchPageDataChanged);
				sidePanelService.closeView(sidePanelService.currentView);
				notificationService.success(internationalization.getFormatted('solutionBuilderAgent.actions.wizard.success', action.title));
			}
		},
	]);
})();
